import React from 'react';
import { SHIP_FREE_MODAL_PATH } from '@/utils/constants/order';
import { timeAgo } from '@/utils/ts/stringUtils';
import { IBulkOrderProcessingFailureNotification } from '@Saral-Influencer-Marketing/saral-utils/src/types';
import { useNavigate } from 'react-router-dom';

import RightArrow from '@/components/Icons/icons/RightArrow';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

interface Props {
  notification: IBulkOrderProcessingFailureNotification;
  setShowNotificationDropdown: React.Dispatch<React.SetStateAction<boolean>>;
}

const BulkOrderPlacementNotification = ({ notification, setShowNotificationDropdown }: Props) => {
  const influencerContent = notification?.content;
  const influencerProfileImg = influencerContent?.profileImg || '';
  const influencerName = influencerContent?.influencerName;

  const navigate = useNavigate();

  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent src={influencerProfileImg} alt={influencerName} />
      </div>
      <div className="text-div">
        <h3 className="title">{notification?.title}</h3>
        <p className="description">{notification?.description}</p>

        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={() => {
              navigate(
                `/dashboard/profile/${influencerContent?.listId}/${influencerContent?.influencerId}?${SHIP_FREE_MODAL_PATH}=true`
              );
              setShowNotificationDropdown(false);
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">Retry</span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default BulkOrderPlacementNotification;
